
// TODO invite guests form
import styles from "./GalleryDetail.module.scss";
import * as React from "react";

import { ActionLink } from "../ActionLink";
import { GalleryIcon } from "../Icons/Gallery";
import { ScheduleMessageIcon } from "../Icons/ScheduleMessage";
import { DisplayIcon } from "../Icons/Display";
import { GuestsIcon } from "../Icons/Guests";
import { ManageQueueIcon } from "../Icons/ManageQueue";
import { UploadIcon } from "../Icons/Upload";
import { SignShopIcon } from "../Icons/SignShop";
import { DownloadingIcon } from "../Icons/Downloading";
import { GalleryDownloadIcon } from "../Icons/GalleryDownload";

/** GalleryDetail properties. */
export interface GalleryDetailProps {
    id: number;
    host_id: number;
    display_name: string;
    avatar: string;
    date: string;
    short_url: string;
    upload_url: string;
    live_url?: string;
    phone?: string;
    hashtag?: string;
    onArchive: () => void;
    is_archiving: boolean;
    is_super_host: boolean;
    tourGallery: boolean;
    tourLive: boolean;
    tourQueue: boolean;
}

export const GalleryDetail = (props: GalleryDetailProps) => {
    const parts = props.date.split("-");
    const months = [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    const date = `${months[parseInt(parts[1])]} ${parseInt(parts[2], 10)}, ${parts[0]}`
 
    return (
        <div className={styles["gallery-detail"]}>
            <div className={styles["gallery-identity-container"]}>
                <div className={styles["gallery-img-container"]}>
                    <img src={props.avatar} />
                    <h1>
                        {props.display_name}
                        <p className={styles["gallery-detail-data"]}>{date}</p>
                    </h1>
                </div>
     
                <p className={`${styles["gallery-detail-link"]} ${styles["edit-gallery-details"]}`}>
                    <ActionLink to={`/dashboard/galleries/${props.id}/edit`} className={styles["action-link"]}>
                        edit details
                    </ActionLink>
                </p>
                {props.is_super_host && (<p className={`${styles["gallery-detail-link"]} ${styles["manage-cohosts"]}`}>
                    <ActionLink to={`/dashboard/galleries/${props.id}/cohosts`} className={styles["action-link"]}>manage cohosts</ActionLink>
                </p>)}
            </div>
            
            
            <div className={styles["gallery-identities-box"]}>
                <div className={styles["gallery-identity-container-column"]}>
                    <p className={styles["gallery-detail-label"]}>Your Gallery&rsquo;s Number</p>
                    <p className={styles["gallery-detail-data"]}>{props.phone}</p>
                    <p className={styles["gallery-detail-link"]}>
                        <ActionLink to={location.pathname + "/invite"} className={styles["action-link"]}>
                            share number
                        </ActionLink>
                    </p>
                </div>

                <div className={styles["gallery-identity-container-column"]}>
                    <p className={styles["gallery-detail-label"]}>Your Gallery&rsquo;s Link</p>
                    <p className={styles["gallery-detail-data"]}>{props.short_url.replace("http://", "")}</p>
                    <p className={styles["gallery-detail-link"]}>
                        <ActionLink to={location.pathname + "/invite"} className={styles["action-link"]}>
                            share link
                        </ActionLink>
                    </p>
                </div>
            </div>

            <div className={styles["manage-display-container"]}>
                    
                <ActionLink href={props.short_url} className={styles["browse-bd-button"]} classes={[styles["action-link"]]}>
                    <span className={styles["icon-circle"]}>
                        <GalleryIcon />
                    </span>
                    View Gallery
                    {props.tourGallery && <span className={styles["circle"]}></span>}
                </ActionLink>
                
                {props.live_url && (
                    <ActionLink href={props.live_url} classes={[styles["live-bd-button"], styles["action-link"]]}>
                        <span className={styles["icon-circle"]}>
                            <DisplayIcon />
                        </span>
                        Display Live
                        {props.tourLive && <span className={styles["circle"]}></span>}
                    </ActionLink>)
                }

                {props.live_url && (
                    <ActionLink to={location.pathname + "/message-scheduler"} classes={[styles["action-link"]]}>
                        <span className={styles["icon-circle"]}>
                            <ScheduleMessageIcon />
                        </span>
                        Schedule Messages
                        {props.tourLive && <span className={styles["circle"]}></span>}
                    </ActionLink>)
                }
                
                <ActionLink to={`/dashboard/galleries/${props.id}/tacs`} classes={[styles["manage-bd-button"], styles["action-link"]]}>
                    <span className={styles["icon-circle"]}>
                        <GuestsIcon />
                    </span>
                    Manage Guests
                    {props.tourQueue && <span className={styles["circle"]}></span>}
                </ActionLink>
                
                
                
                 <ActionLink href={props.upload_url} classes={[styles["browse-bd-button"], styles["action-link"]]}>
                    <span className={styles["icon-circle"]}>
                        <UploadIcon />
                    </span>
                    Upload Photos
                    {props.tourGallery && <span className={styles["circle"]}></span>}
                </ActionLink>
                
                <ActionLink to={`/dashboard/galleries/${props.id}/tacs`} classes={[styles["manage-bd-button"], styles["action-link"]]}>
                    <span className={styles["icon-circle"]}>
                        <ManageQueueIcon />
                    </span>
                    Maintain Queue
                    {props.tourQueue && <span className={styles["circle"]}></span>}
                </ActionLink>
                
            </div>
            
            <div className={styles["secondary-actions-container"]}>
                <ActionLink classes={[styles["secondary-action-box"], styles["action-link"]]} href={"https://tacboard.com/wedding-sign-shop.html?phone=" + props.phone}>
                    <SignShopIcon />
                    <p>Visit Sign Shop</p>
                </ActionLink>
                
                <div className={styles["secondary-action-box"]}>{props.is_archiving ? (
                    <span>
                        <div className={styles["downloadPrepMsgOverlay"]}>
                            <DownloadingIcon />
                            <div className={styles["downloadPrepMsg"]}>We're preparing your gallery. This may take several seconds. When this message leaves your gallery will begin downloading. A download link will also be emailed to you.</div>
                        </div>
                    </span>
                    ) : (
                        <ActionLink onClick={props.onArchive} classes={[styles["action-link"]]}>
                            <GalleryDownloadIcon />
                            <p>download gallery</p>
                        </ActionLink>
                    )}
                </div>
            </div>
            
            
            <div className={styles["userguide-container"]}>
                <ActionLink href="https://tacboard.com/welcome-overview.html" classes={[styles["action-link"]]}>
                    View User Guide
                </ActionLink>
            </div>
        </div>
    );
};

export default GalleryDetail;
